
import React, { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AppRoutes from './routes/index';
import { useAuthStore } from './stores/auth.store';
import { paginaDiAccesso } from './lib/sessione';

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-full bg-bg-light">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-text-mid text-sm font-medium">Caricamento...</p>
      </div>
    </div>
  );
}

// Lazy-load heavy features to avoid module initialization issues
const SessionGuard = React.lazy(() => import('./components/SessionGuard'));
const KeyboardShortcutsHelp = React.lazy(() => import('./components/KeyboardShortcutsHelp'));
const PwaManager = React.lazy(() => import('./components/pwa/PwaManager'));

export default function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  // Sulle pagine di accesso la sorveglianza della sessione resta spenta.
  // Il rinnovo periodico, il conto alla rovescia e la finestra «sessione
  // persa» appartengono a una sessione che sta lavorando: su /login e
  // /sso-callback i resti di quella vecchia correvano contro l'accesso nuovo
  // — nei log del server si vede /auth/oidc/complete rispondere 200 e subito
  // dopo una raffica di /auth/refresh 401 con il token già morto.
  const { pathname } = useLocation();
  const inAccesso = paginaDiAccesso(pathname);

  return (
    <Suspense fallback={<LoadingFallback />}>
      {isAuthenticated && !inAccesso && (
        <Suspense fallback={null}>
          <SessionGuard />
        </Suspense>
      )}
      {/* PWA install / update / offline banners — self-gating, work pre- and
          post-login. */}
      <Suspense fallback={null}>
        <PwaManager />
      </Suspense>
      <AppRoutes />
    </Suspense>
  );
}
